<p>loggedout works!</p>
